module.exports = __webpack_public_path__ + "static/img/parts.05b664b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/parts.jpg
// module id = QA12
// module chunks = 2